import Odometer from "odometer";
import {isInViewport} from "./helpers";

const callCounters = (divWithCounters) => {
  if (!divWithCounters) {
    return;
  }
  // console.log("isInViewport(divWithCounters)", isInViewport(divWithCounters));
  if (!divWithCounters || !isInViewport(divWithCounters) || divWithCounters.classList.contains("counters-finished")) {
    return
  }
  const counters = divWithCounters.querySelectorAll('.count2-number__value');
  if (!counters) {
    return;
  }
  divWithCounters.classList.add("counters-finished");

  counters.forEach(counter => {
    const valueTo = +counter.getAttribute('data-target') || 100;
    const od = new Odometer({
      format: 'd',
      el: counter,
      duration: 2000,

      // Any option (other than auto and selector) can be passed in here
      // format: '',
      // duration: 3000,
      // animation: 'count',
      // theme: 'default'
    });
    od.update(valueTo);
  });
}

document.addEventListener("DOMContentLoaded", () => {
  const countersSection7 = document.getElementById("count2");
  callCounters(countersSection7);

  document.addEventListener('scroll', function () {
    callCounters(countersSection7);
  }, {
    passive: true
  });

});